import {
  Box,
  Button,
  Drawer,
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormControlLabel,
  Checkbox,
  Link,
  Tabs,
  Tab,
  Divider,
  Switch,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { rem, numberFormat, replaceBrTag } from "assets/js/common";
import { useDispatch } from "react-redux";
import { loadAction } from "redux/reducers/top";
import PropTypes from "prop-types";
import moment from "moment";
import AlertComplete from "components/ui/alert-complete";
import DrawerReceipt from "components/ui/drawer-receipt";
import ReceiptDrawer from "../../components/receipt/receiptdrawer";
import Loading from "components/ui/loading";
import { useHistory } from "react-router-dom";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      className="tabpanel"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const label = { inputProps: { "aria-label": "Switch demo" } };

const useStyles = makeStyles((theme) => ({
  receipt: {
    "& .border-top": {
      borderTop: "1px solid #eee",
      padding: 0,
    },
    "& .nodata": {
      marginTop: rem(25),
      borderTop: `1px solid ${theme.palette.grey[100]}`,
    },
  },
}));

export default function receipt(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const [open, setOpen] = useState(false);

  const [val, setVal] = useState(0);
  const [drawerSave, setDrawerSave] = useState(false);
  const [arrList, setArrList] = useState([]);
  const [receiptList, setReceiptList] = useState([]);

  const [userInfo, setUserInfo] = useState("");
  const [schYm, setSchYm] = useState("");
  const [receiptDetail, setReceiptDetail] = useState("");
  const [fetching, setFetching] = useState(false);
  const [mallAlert, setMallAlert] = useState(false);
  const [barcodeNum, setBarcodeNum] = useState("");
  const [storeCode, setStoreCode] = useState("");

  const [drawerFull, setDrawerFull] = useState(false);
  const handleChangeTab = (event, newValue) => {
    setVal(newValue);
    setSchYm(arrList[newValue]);
  };

  const loadUserInfo = async () => {
    await axios.get("/api/mb/member/my-info").then((res) => {
      setUserInfo(res.data.data.member);
    });
  };

  const handleChangeReceipt = async (e) => {
    let checked = e.target.checked;
    // setMblRctYn(checked);
    await axios
      .post("/api/mb/member/modify-mobile-receipt", {
        mblRctYn: checked ? "Y" : "N",
      })
      .then((res) => {
        if (res.data.data) {
          loadUserInfo();
        }
      });
  };

  const setSelectedMonth = () => {
    let today = moment();
    let start = today.subtract(5, "M");
    let arr = [start.format("YYYYMM")];

    for (let i = 0; i < 5; i++) {
      arr.push(start.add(1, "M").format("YYYYMM"));
    }
    setArrList(arr);
    console.log("arr", arr);
    setSchYm(arr[5]);
    setVal(5);
  };

  const loadReceiptList = async () => {
    setFetching(true);
    await axios
      .get("/api/mb/receipt", {
        params: {
          schYear: schYm.slice(0, 4),
          schMonth: schYm.slice(4),
        },
      })
      .then((res) => {
        setReceiptList(res.data.data.receiptList);
        setFetching(false);
      })
      .catch((error) => {
        setFetching(false);
      });
  };

  const loadReceiptDetail = async (data) => {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/mb/receipt/get", {
          params: {
            saleDate: data.saleDate,
            storeCode: data.storeCode,
            posNo: data.posId,
            tranNo: data.tranId,
          },
        })
        .then((res) => {
          setBarcodeNum(data.saleDate + data.posId + data.tranId);
          setStoreCode(data.storeCode);
          // setReceiptDetail(
          //   `[등 록] 2022/02/15(화) 10:56 POS No:0101\r\n거래번호:6397  총    4개 판매원:박저희  \r\n----------------------------------------\r\n상품명              단가  수량      금액\r\n----------------------------------------\r\n01 고품격불가리스플레인                 \r\n   8801069217987   4,980    1      4,980\r\n02 하우즈데코)종이컵                    \r\n   8809436053411   1,100    1      1,100\r\n03 신형부직포장바구니                   \r\n   13408572          500    1        500\r\n04#목장신선우유                         \r\n   8801115114260   3,300    1      3,300\r\n상품명앞 \"#\"은 면세 \"*\"는 위수탁 입니다.\r\n\u001b|2C합 계       9,880 원\u001b|1C\r\n----------------------------------------\r\n받 을 돈                        9,880 원\r\n\r\nKB국민체크카드                  9,880 원\r\n카드번호(IC)        5272-89**-****-8302 \r\n할부                        [  0 개월 ]\r\n승인번호                    30025852    \r\n--------<  판  매  영  수  증  >--------\r\n000 (주)메가 607-85-13185  대표:김경조  \r\n합  계:     9,880원  과세품:     5,982원\r\n면세품:     3,300원  부가세:       598원\r\n\r\n▶반품은 구매하신일로 7일 이내 가능\r\n (농산/수산/축산물,냉장/냉동상품/\r\n 베이커리/도서제품은 당일만 가능)\r\n 교환,반품시 사은품은 반환 必       \r\n▶포인트 적립은 30일 이내 가능\r\n▶메가마트 동래점은 정부시책으로 인해   \r\n  매월 둘째,넷째 일요일 휴무실시하며    \r\n  영업시간은  오전 8시부터 ~ 03시까지\r\n거래바코드출력\r\n`
          // );
          setReceiptDetail(res.data.data);
          setDrawerFull(true);
          resolve(true);
        })
        .catch((err) => {
          setFetching(false);
        });
    });
    await axios
      .get("/api/mb/receipt/get", {
        params: {
          saleDate: data.saleDate,
          storeCode: data.storeCode,
          posNo: data.posId,
          tranNo: data.tranId,
        },
      })
      .then((res) => {
        setReceiptDetail(res.data.data);
      });
  };

  const handleAlertClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (schYm) {
      loadReceiptList();
    }
  }, [schYm]);

  window.appBackKeyHandle = () => {
    if (open) {
      handleAlertClose();
    } else {
      history.goBack();
    }
  };

  useEffect(() => {
    dispatch(loadAction({ back: true, title: "모바일 영수증", menu: true }));
    window.scrollTo(0, 0);
    loadUserInfo();
    setSelectedMonth();
    // setDrawerFull(true);
  }, []);

  const handleSelected = async (receipt) => {
    if (receipt.mallFlag == "0") {
      await loadReceiptDetail(receipt);
    } else {
      setMallAlert(true);
    }
  };

  const handleCancel = () => {
    setDrawerFull(false);
  };

  const getTitle = (receipt) => {
    return receipt.storeCode == "2928"
      ? "제휴카드 추가"
      : receipt.mallFlag == "0"
      ? receipt.storeName
      : "메가마트몰";
  };

  const getSaleDate = (receipt) => {
    return moment(`${receipt.saleDate} ${receipt.saleTime}`).format(
      "YYYY.MM.DD HH:mm:SS"
    );
  };

  const getAmountSign = (receipt) => {
    let result = "";
    if (receipt.useFlag == "1") {
      result = receipt.saleAmount > -1 ? "" : "del";
    } else if (receipt.useFlag == "2") {
      result = receipt.saleAmount < 0 ? "" : "del";
    }
    return result;
  };

  return (
    <>
      <Loading open={fetching} />
      <div className={"container nopad " + classes.receipt}>
        {userInfo && (
          <div className="receipt-select bg-grey">
            <dl>
              <dt>모바일 영수증만 받기</dt>
              {userInfo.mblRctYn == "Y" ? (
                <dd>
                  종이 영수증이 발급되지 않습니다.
                  <br />
                  필요하신 경우 계산대에 요청해주세요.
                </dd>
              ) : (
                <dd>
                  모바일 영수증이 발급되지 않습니다.
                  <br />
                  발급을 원하실 경우 설정을 변경해주세요.
                </dd>
              )}
            </dl>
            <Switch
              {...label}
              size="medium"
              checked={userInfo.mblRctYn == "Y"}
              onChange={handleChangeReceipt}
            />
          </div>
        )}
        <div className="receipt-month">
          <strong className="select-month">
            {moment(schYm).format("YYYY. MM")}
          </strong>

          <Tabs
            value={val}
            onChange={handleChangeTab}
            variant="scrollable"
            scrollButtons="auto"
            TabIndicatorProps={{ children: <span /> }}
          >
            {arrList.map((item, i) => (
              <Tab
                key={i}
                label={
                  <span className="month">
                    {item.slice(0, 4)}
                    <b>{item.slice(4, 6)}</b>
                  </span>
                }
              />
            ))}
          </Tabs>
          {receiptList.length == 0 && (
            <div className="nodata" style={{ padding: "75px 0 60px" }}>
              <Box className="illust">
                <img src={`${process.env.PUBLIC_URL}/images/icon/nodata.svg`} />
              </Box>
              <p className="color-info">조회된 내역이 없습니다</p>
            </div>
          )}
          <ul className="receipt-list">
            {receiptList.map((receipt, i) => (
              <li
                key={i}
                className="mart"
                onClick={() => handleSelected(receipt)}
              >
                <Link to="" className={receipt.storeTp == "1" ? "" : "mall"}>
                  <div className="title-group">
                    <p className="store">{getTitle(receipt)}</p>
                    <span className="date">{getSaleDate(receipt)}</span>
                  </div>
                  <div className="price">
                    {getAmountSign(receipt) != "del" ? (
                      <>{numberFormat(receipt.saleAmount)}원</>
                    ) : (
                      <del>{numberFormat(receipt.saleAmount)}원</del>
                    )}
                  </div>
                </Link>
              </li>
            ))}
          </ul>

          <div className="btn-wrap" style={{ marginTop: rem(40) }}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => {
                setOpen(true);
              }}
            >
              포인트 추후 적립
            </Button>
          </div>
        </div>
        <Box className="notice is-bottom border-top">
          <p className="title">
            <i className="ico-noti" />
            유의사항
          </p>
          <ul className="list list-dot color-info font-14">
            <li>최근 6개월간 구매내역만 표기됩니다.</li>
            <li>결제 후 메가포인트를 적립한 내역만 표기됩니다.</li>
            <li>
              모바일영수증은 ON 상태로 설정하시면 종이영수증 대신 모바일영수증이
              기본으로 발급됩니다.
            </li>
          </ul>
        </Box>

        <ReceiptDrawer
          drawerFull={drawerFull}
          receiptDetail={receiptDetail}
          handleCancel={handleCancel}
          barcodeNum={barcodeNum}
          storeCode={storeCode}
        />

        {/* <Drawer
        anchor="bottom"
        open={drawerFull}
        onClose={() => setDrawerFull(false)}
        className="drawer-common-bottom size-full title-center"
      >
        <div className="drawer-head">
          <h3 className="weight800">영수증 상세</h3>
          <IconButton
            aria-label="close"
            className="btn-close"
            onClick={() => setDrawerFull(false)}
          >
            <span className="hidden">닫기</span>
          </IconButton>
        </div>

        <div className="drawer-body">
          <Box
            p={8}
            dangerouslySetInnerHTML={{
              __html: replaceBrTag(receiptDetail)
                ? replaceBrTag(receiptDetail)
                : "",
            }}
            style={{
              fontFamily: "굴림",
              fontSize: rem(13),
              textAlign: "center",
            }}
          />
        </div>
      </Drawer> */}

        <DrawerReceipt
          open={open}
          handleDrawerClose={handleAlertClose}
          callback={loadReceiptList}
        />

        {/* <AlertComplete
        open={openAlert}
        handleAlertClose={() => {
          setOpenAlert(false);
        }}
        text={`모바일 영수증이 발급되지 않습니다.<br />발급을 원하실경우 설정을 변경해주세요.`}
        action={() => {
          setOpenAlert(false);
        }}
      /> */}
        <AlertComplete
          open={mallAlert}
          handleAlertClose={() => {
            setMallAlert(false);
          }}
          text={`메가마트 몰에서 확인해주시기 바랍니다.`}
          action={() => {
            setMallAlert(false);
          }}
        />
      </div>
    </>
  );
}
